import { FontTheme } from '@kite-js/theme-types';
import colors from '@theme/priceline/theme-priceline/colors';
import basicLineHeights from './basicLineHeights';
import faces from './faces';
import families from './families';
import familiesByLanguage from './familiesByLanguage';
import sizes from './sizes';
import tallerLineHeights from './tallerLineHeights';
import weights from './weights';

const font: FontTheme = {
    basicLineHeights,
    sizes,
    weights,
    faces,
    familiesByLanguage,
    tallerLineHeights,
    family: [families.montserrat, families.helveticaNeue, families.helvetica, families.arial, families.sansSerif].join(
        ','
    ),
    defaultColor: colors.textScale[800],
};

export default font;
